<template>

  <div class="PlayerCard card">
    <img class="cardLogo" v-bind:src="player.stats.quickplay.overall_stats.avatar">
    <div class="playerName">{{ parsedPlayerName }}</div>
    <div v-if="hasPlayedCompetitive" class="playerRank">{{rank}}</div>
    <img v-if="hasPlayedCompetitive" class="playerRankLogo" v-bind:src="tierImage" alt="">
    <img class="playerHero" v-bind:src="heroImage">
    <div v-if="edit" class="playerRemove red-glow" v-on:click="removePlayer"></div>
  </div>

</template>

<script>
export default {
  name: 'PlayerCard',
  props: ["player", "teamId","edit"],


  computed: {
    parsedPlayerName(){
      var name = this.player.name;
      var split = name.split('-',1);
      return split[0];
    },
    hasPlayedCompetitive(){
      return (this.player.stats.competitive != null);
    },
    tierImage(){
      return this.player.stats.competitive.overall_stats.tier_image;
    },
    heroImage(){
      var heroes;
      var mostPlayedTime = 0;
      var mostPlayedHero = "";

      if(this.hasPlayedCompetitive){
        heroes = this.player.playtime.competitive;
      }else{
        heroes = this.player.playtime.quickplay;
      }

      for(var key in heroes){
        if(heroes[key] > mostPlayedTime){
          mostPlayedTime = heroes[key];
          mostPlayedHero = key;
        }
      }

      if(mostPlayedHero === "soldier76"){
        mostPlayedHero = "soldier-76";
      }

      return 'https://blzgdapipro-a.akamaihd.net/hero/' + mostPlayedHero + '/icon-portrait.png';

    },
    rank(){
      return this.player.stats.competitive.overall_stats.comprank;
    }
  },

  methods: {
    removePlayer(){
      this.$store.dispatch('removePlayer',{playerId: this.player.id, teamId: this.teamId})
      this.$store.dispatch('calculateTeamStats',this.teamId);
    }
  }
}
</script>


<style scoped>

.PlayerCard{
  display: grid;
  /*justify-content: flex-start;*/
  /*grid-column-gap: 15px;*/
  grid-template-columns: 100px auto minmax(50px,112px) 30px;
  grid-template-areas:
    'cardLogo playerName playerHero playerRemove'
    'cardLogo playerRank playerHero playerRemove';
}
.card{
  cursor: default;
}

.cardLogo{
  grid-area: cardLogo;

  height: 100px;
  width: 100px;
  -o-object-fit: cover;
  object-fit: cover;
}

.playerInfo{
  display: grid;
  justify-content: start;
  grid-gap: 0px;
  grid-template-areas:
    'playerName'
    'playerRank';
}

.playerName{
  grid-area: playerName;

  font-size: 25px;
  margin-top: auto;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.playerRank{
  grid-area: playerRank;

  font-size: 20px;
  margin-top: 0px;
  margin-left: 45px;
}

.playerRankLogo{
  grid-area: playerRank;
  width: 32px;
  margin-top: 0px;
  margin-left: 10px;
}

.playerHero{
  grid-area: playerHero;
  justify-self: right;
}
.playerRemove{
  grid-area: playerRemove;
  text-align: center;
  margin: auto;
  margin-right: 10px;
  background-image: url(../assets/removePlayer.png);
  width: 30px;
  height: 100px;
  background-size: 30px 100px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PlayerCard.vue